import { render, staticRenderFns } from "./textToItem.vue?vue&type=template&id=5aa87fa8&"
import script from "./textToItem.vue?vue&type=script&lang=js&"
export * from "./textToItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports